var $, _;
if (typeof module === 'object' && module.exports) {
	$ = require('jquery');
	_ = require('underscore');
}

var LegacyClient = function LegacyClient() {
	var self = this;
	self.sharedHeaders = {};

	// Adds an Authorization header to send along with any
	//   requests through using this instance of the client
	self.addAuth = function(value) {
		self.sharedHeaders["Authorization"] = value;
	}
	self.removeAuth = function() {
		delete self.sharedHeaders["Authorization"];
	}

	// api.postBooks((primary_parameters), (additional_parameters), callback)
//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
self.postBooks = function() {
	var data = null;
	var postBinaryBody = null;
	var extraParameters = null;

	var url = getUrlBase() + "/api/v1/books";
	url += ".json";

	url = url;

	var queryParams = {};
	var headerParams =  {};

	if ((arguments.length > 1) && arguments[0]) { data = JSON.stringify(arguments[0]); }
	if ((arguments.length > 2) && arguments[1]) { extraParameters = arguments[1]; }

	var callback = arguments[arguments.length - 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	var mimeTypes = undefined;
	var contentType = "application/json";
	var processData = true;

	if (extraParameters != null) {
		if (extraParameters['query']) {
			_.extend(queryParams, extraParameters['query']);
		}
		if (extraParameters['header']) {
			_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
		}
		if (extraParameters['form']) {
			data = extraParameters['form'];
			mimeTypes = "multipart/form-data";
			contentType = false;
			processData = false;
		}
		if (extraParameters['body']) {
 			data = JSON.stringify(extraParameters['body']);
		}
	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		type: "POST",
		async: true,
		contentType: contentType,
		mimeTypes: mimeTypes,
		dataType: "json",
		processData: processData,
		data: data,
		headers: headerParams
	};
	var request = $.ajax(url, options);

	request.fail(function(jqXHR, textStatus, errorThrown){
		if (callback) {
			callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
		}
	});

	request.done(function(response, textStatus, jqXHR){
		if (callback) {
			callback(response, true, jqXHR.status, jqXHR);
		}
	});

	return request;
}

// api.getScopedBooks(scope, (primary_parameters), (additional_parameters), callback)
//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
self.getScopedBooks = function() {
	var data = null;
	var postBinaryBody = null;
	var extraParameters = null;

	var url = getUrlBase() + "/api/v1/books/{scope}";
	url += ".json";

	url = url.replace('{scope}', arguments[0]);

	var queryParams = {};
	var headerParams =  {};

	if ((arguments.length > 2) && arguments[1]) { _.extend(queryParams, arguments[1]); }
	if ((arguments.length > 3) && arguments[2]) { extraParameters = arguments[2]; }

	var callback = arguments[arguments.length - 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	var mimeTypes = undefined;
	var contentType = "application/json";
	var processData = true;

	if (extraParameters != null) {
		if (extraParameters['query']) {
			_.extend(queryParams, extraParameters['query']);
		}
		if (extraParameters['header']) {
			_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
		}
		if (extraParameters['form']) {
			data = extraParameters['form'];
			mimeTypes = "multipart/form-data";
			contentType = false;
			processData = false;
		}
		if (extraParameters['body']) {
 			data = JSON.stringify(extraParameters['body']);
		}
	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		type: "GET",
		async: true,
		contentType: contentType,
		mimeTypes: mimeTypes,
		dataType: "json",
		processData: processData,
		data: data,
		headers: headerParams
	};
	var request = $.ajax(url, options);

	request.fail(function(jqXHR, textStatus, errorThrown){
		if (callback) {
			callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
		}
	});

	request.done(function(response, textStatus, jqXHR){
		if (callback) {
			callback(response, true, jqXHR.status, jqXHR);
		}
	});

	return request;
}

// api.getScopedBook(scope, id, (primary_parameters), (additional_parameters), callback)
//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
self.getScopedBook = function() {
	var data = null;
	var postBinaryBody = null;
	var extraParameters = null;

	var url = getUrlBase() + "/api/v1/books/{scope}/{id}";
	url += ".json";

	url = url.replace('{scope}', arguments[0]).replace('{id}', arguments[1]);

	var queryParams = {};
	var headerParams =  {};

	if ((arguments.length > 3) && arguments[2]) { _.extend(queryParams, arguments[2]); }
	if ((arguments.length > 4) && arguments[3]) { extraParameters = arguments[3]; }

	var callback = arguments[arguments.length - 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	var mimeTypes = undefined;
	var contentType = "application/json";
	var processData = true;

	if (extraParameters != null) {
		if (extraParameters['query']) {
			_.extend(queryParams, extraParameters['query']);
		}
		if (extraParameters['header']) {
			_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
		}
		if (extraParameters['form']) {
			data = extraParameters['form'];
			mimeTypes = "multipart/form-data";
			contentType = false;
			processData = false;
		}
		if (extraParameters['body']) {
 			data = JSON.stringify(extraParameters['body']);
		}
	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		type: "GET",
		async: true,
		contentType: contentType,
		mimeTypes: mimeTypes,
		dataType: "json",
		processData: processData,
		data: data,
		headers: headerParams
	};
	var request = $.ajax(url, options);

	request.fail(function(jqXHR, textStatus, errorThrown){
		if (callback) {
			callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
		}
	});

	request.done(function(response, textStatus, jqXHR){
		if (callback) {
			callback(response, true, jqXHR.status, jqXHR);
		}
	});

	return request;
}

// api.patchScopedBook(scope, id, (primary_parameters), (additional_parameters), callback)
//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
self.patchScopedBook = function() {
	var data = null;
	var postBinaryBody = null;
	var extraParameters = null;

	var url = getUrlBase() + "/api/v1/books/{scope}/{id}";
	url += ".json";

	url = url.replace('{scope}', arguments[0]).replace('{id}', arguments[1]);

	var queryParams = {};
	var headerParams =  {};

	if ((arguments.length > 3) && arguments[2]) { data = JSON.stringify(arguments[2]); }
	if ((arguments.length > 4) && arguments[3]) { extraParameters = arguments[3]; }

	var callback = arguments[arguments.length - 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	var mimeTypes = undefined;
	var contentType = "application/json";
	var processData = true;

	if (extraParameters != null) {
		if (extraParameters['query']) {
			_.extend(queryParams, extraParameters['query']);
		}
		if (extraParameters['header']) {
			_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
		}
		if (extraParameters['form']) {
			data = extraParameters['form'];
			mimeTypes = "multipart/form-data";
			contentType = false;
			processData = false;
		}
		if (extraParameters['body']) {
 			data = JSON.stringify(extraParameters['body']);
		}
	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		type: "PATCH",
		async: true,
		contentType: contentType,
		mimeTypes: mimeTypes,
		dataType: "json",
		processData: processData,
		data: data,
		headers: headerParams
	};
	var request = $.ajax(url, options);

	request.fail(function(jqXHR, textStatus, errorThrown){
		if (callback) {
			callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
		}
	});

	request.done(function(response, textStatus, jqXHR){
		if (callback) {
			callback(response, true, jqXHR.status, jqXHR);
		}
	});

	return request;
}

// api.getLibraryOnline((primary_parameters), (additional_parameters), callback)
//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
self.getLibraryOnline = function() {
	var data = null;
	var postBinaryBody = null;
	var extraParameters = null;

	var url = getUrlBase() + "/api/v1/library/online";
	url += ".json";

	url = url;

	var queryParams = {};
	var headerParams =  {};

	if ((arguments.length > 1) && arguments[0]) { _.extend(queryParams, arguments[0]); }
	if ((arguments.length > 2) && arguments[1]) { extraParameters = arguments[1]; }

	var callback = arguments[arguments.length - 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	var mimeTypes = undefined;
	var contentType = "application/json";
	var processData = true;

	if (extraParameters != null) {
		if (extraParameters['query']) {
			_.extend(queryParams, extraParameters['query']);
		}
		if (extraParameters['header']) {
			_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
		}
		if (extraParameters['form']) {
			data = extraParameters['form'];
			mimeTypes = "multipart/form-data";
			contentType = false;
			processData = false;
		}
		if (extraParameters['body']) {
 			data = JSON.stringify(extraParameters['body']);
		}
	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		type: "GET",
		async: true,
		contentType: contentType,
		mimeTypes: mimeTypes,
		dataType: "json",
		processData: processData,
		data: data,
		headers: headerParams
	};
	var request = $.ajax(url, options);

	request.fail(function(jqXHR, textStatus, errorThrown){
		if (callback) {
			callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
		}
	});

	request.done(function(response, textStatus, jqXHR){
		if (callback) {
			callback(response, true, jqXHR.status, jqXHR);
		}
	});

	return request;
}

// api.getLibraryPlatforms((primary_parameters), (additional_parameters), callback)
//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
self.getLibraryPlatforms = function() {
	var data = null;
	var postBinaryBody = null;
	var extraParameters = null;

	var url = getUrlBase() + "/api/v1/library/platforms";
	url += ".json";

	url = url;

	var queryParams = {};
	var headerParams =  {};

	if ((arguments.length > 1) && arguments[0]) { _.extend(queryParams, arguments[0]); }
	if ((arguments.length > 2) && arguments[1]) { extraParameters = arguments[1]; }

	var callback = arguments[arguments.length - 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	var mimeTypes = undefined;
	var contentType = "application/json";
	var processData = true;

	if (extraParameters != null) {
		if (extraParameters['query']) {
			_.extend(queryParams, extraParameters['query']);
		}
		if (extraParameters['header']) {
			_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
		}
		if (extraParameters['form']) {
			data = extraParameters['form'];
			mimeTypes = "multipart/form-data";
			contentType = false;
			processData = false;
		}
		if (extraParameters['body']) {
 			data = JSON.stringify(extraParameters['body']);
		}
	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		type: "GET",
		async: true,
		contentType: contentType,
		mimeTypes: mimeTypes,
		dataType: "json",
		processData: processData,
		data: data,
		headers: headerParams
	};
	var request = $.ajax(url, options);

	request.fail(function(jqXHR, textStatus, errorThrown){
		if (callback) {
			callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
		}
	});

	request.done(function(response, textStatus, jqXHR){
		if (callback) {
			callback(response, true, jqXHR.status, jqXHR);
		}
	});

	return request;
}

// api.getScopedLookup(scope, (primary_parameters), (additional_parameters), callback)
//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
self.getScopedLookup = function() {
	var data = null;
	var postBinaryBody = null;
	var extraParameters = null;

	var url = getUrlBase() + "/api/v1/lookup/{scope}";
	url += ".json";

	url = url.replace('{scope}', arguments[0]);

	var queryParams = {};
	var headerParams =  {};

	if ((arguments.length > 2) && arguments[1]) { _.extend(queryParams, arguments[1]); }
	if ((arguments.length > 3) && arguments[2]) { extraParameters = arguments[2]; }

	var callback = arguments[arguments.length - 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	var mimeTypes = undefined;
	var contentType = "application/json";
	var processData = true;

	if (extraParameters != null) {
		if (extraParameters['query']) {
			_.extend(queryParams, extraParameters['query']);
		}
		if (extraParameters['header']) {
			_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
		}
		if (extraParameters['form']) {
			data = extraParameters['form'];
			mimeTypes = "multipart/form-data";
			contentType = false;
			processData = false;
		}
		if (extraParameters['body']) {
 			data = JSON.stringify(extraParameters['body']);
		}
	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		type: "GET",
		async: true,
		contentType: contentType,
		mimeTypes: mimeTypes,
		dataType: "json",
		processData: processData,
		data: data,
		headers: headerParams
	};
	var request = $.ajax(url, options);

	request.fail(function(jqXHR, textStatus, errorThrown){
		if (callback) {
			callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
		}
	});

	request.done(function(response, textStatus, jqXHR){
		if (callback) {
			callback(response, true, jqXHR.status, jqXHR);
		}
	});

	return request;
}

// api.postScopedLookup(scope, (primary_parameters), (additional_parameters), callback)
//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
self.postScopedLookup = function() {
	var data = null;
	var postBinaryBody = null;
	var extraParameters = null;

	var url = getUrlBase() + "/api/v1/lookup/{scope}";
	url += ".json";

	url = url.replace('{scope}', arguments[0]);

	var queryParams = {};
	var headerParams =  {};

	if ((arguments.length > 2) && arguments[1]) { data = JSON.stringify(arguments[1]); }
	if ((arguments.length > 3) && arguments[2]) { extraParameters = arguments[2]; }

	var callback = arguments[arguments.length - 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	var mimeTypes = undefined;
	var contentType = "application/json";
	var processData = true;

	if (extraParameters != null) {
		if (extraParameters['query']) {
			_.extend(queryParams, extraParameters['query']);
		}
		if (extraParameters['header']) {
			_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
		}
		if (extraParameters['form']) {
			data = extraParameters['form'];
			mimeTypes = "multipart/form-data";
			contentType = false;
			processData = false;
		}
		if (extraParameters['body']) {
 			data = JSON.stringify(extraParameters['body']);
		}
	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		type: "POST",
		async: true,
		contentType: contentType,
		mimeTypes: mimeTypes,
		dataType: "json",
		processData: processData,
		data: data,
		headers: headerParams
	};
	var request = $.ajax(url, options);

	request.fail(function(jqXHR, textStatus, errorThrown){
		if (callback) {
			callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
		}
	});

	request.done(function(response, textStatus, jqXHR){
		if (callback) {
			callback(response, true, jqXHR.status, jqXHR);
		}
	});

	return request;
}

// api.postOverrides((primary_parameters), (additional_parameters), callback)
//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
self.postOverrides = function() {
	var data = null;
	var postBinaryBody = null;
	var extraParameters = null;

	var url = getUrlBase() + "/api/v1/overrides";
	url += ".json";

	url = url;

	var queryParams = {};
	var headerParams =  {};

	if ((arguments.length > 1) && arguments[0]) { data = JSON.stringify(arguments[0]); }
	if ((arguments.length > 2) && arguments[1]) { extraParameters = arguments[1]; }

	var callback = arguments[arguments.length - 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	var mimeTypes = undefined;
	var contentType = "application/json";
	var processData = true;

	if (extraParameters != null) {
		if (extraParameters['query']) {
			_.extend(queryParams, extraParameters['query']);
		}
		if (extraParameters['header']) {
			_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
		}
		if (extraParameters['form']) {
			data = extraParameters['form'];
			mimeTypes = "multipart/form-data";
			contentType = false;
			processData = false;
		}
		if (extraParameters['body']) {
 			data = JSON.stringify(extraParameters['body']);
		}
	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		type: "POST",
		async: true,
		contentType: contentType,
		mimeTypes: mimeTypes,
		dataType: "json",
		processData: processData,
		data: data,
		headers: headerParams
	};
	var request = $.ajax(url, options);

	request.fail(function(jqXHR, textStatus, errorThrown){
		if (callback) {
			callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
		}
	});

	request.done(function(response, textStatus, jqXHR){
		if (callback) {
			callback(response, true, jqXHR.status, jqXHR);
		}
	});

	return request;
}

// api.getSearch((primary_parameters), (additional_parameters), callback)
//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
self.getSearch = function() {
	var data = null;
	var postBinaryBody = null;
	var extraParameters = null;

	var url = getUrlBase() + "/api/v1/search";
	url += ".json";

	url = url;

	var queryParams = {};
	var headerParams =  {};

	if ((arguments.length > 1) && arguments[0]) { _.extend(queryParams, arguments[0]); }
	if ((arguments.length > 2) && arguments[1]) { extraParameters = arguments[1]; }

	var callback = arguments[arguments.length - 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	var mimeTypes = undefined;
	var contentType = "application/json";
	var processData = true;

	if (extraParameters != null) {
		if (extraParameters['query']) {
			_.extend(queryParams, extraParameters['query']);
		}
		if (extraParameters['header']) {
			_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
		}
		if (extraParameters['form']) {
			data = extraParameters['form'];
			mimeTypes = "multipart/form-data";
			contentType = false;
			processData = false;
		}
		if (extraParameters['body']) {
 			data = JSON.stringify(extraParameters['body']);
		}
	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		type: "GET",
		async: true,
		contentType: contentType,
		mimeTypes: mimeTypes,
		dataType: "json",
		processData: processData,
		data: data,
		headers: headerParams
	};
	var request = $.ajax(url, options);

	request.fail(function(jqXHR, textStatus, errorThrown){
		if (callback) {
			callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
		}
	});

	request.done(function(response, textStatus, jqXHR){
		if (callback) {
			callback(response, true, jqXHR.status, jqXHR);
		}
	});

	return request;
}


	function replaceAll(haystack, needle, replace) {
		var result= haystack;
		if (needle != null && replace != null) {
			result= haystack.replace(new RegExp(needle, 'g'), replace);
		}
		return result;
	}

 	function createQueryString(queryParams) {
		var queryString ='';
		var i = 0;
		for (var queryParamName in queryParams) {
			if (i == 0) {
				queryString += '?' ;
			} else {
				queryString += '&' ;
			}
			
			queryString += queryParamName + '=' + encodeURIComponent(queryParams[queryParamName]);
			i++;
		}
		
		return queryString;
	}

	function getUrlBase() {
		var protocol = LegacyClient.alternateProtocol || "https";
		var host = LegacyClient.alternateHost || "matilda.savvashortondev.com";
		return protocol + "://" + host;
	}
}

LegacyClient.setHost = function(host, protocol) {
	LegacyClient.alternateHost = host;
	LegacyClient.alternateProtocol = protocol;
}

// export module for Node.js
if (typeof module === 'object' && module.exports) {
	module.exports = LegacyClient;
}



// WEBPACK FOOTER //
// ./modules/wr_apis/apis/matilda_api/node_package/src/legacy_client.js